import _ from 'lodash'
import { RootState } from '../../types/RootState'
import { createSelector } from '@reduxjs/toolkit'

class PlanningRecordsSelectors {
  getPlanningRecords = (state: RootState) => state.planningRecords.planningRecords
  getHasPlanningRecords = (state: RootState) => !!state.planningRecords.planningRecords.length
  getPaginationTimestamp = createSelector(
    [
      (state: RootState) => {
        const createdTimestamp =
          state.planningRecords.planningRecords[state.planningRecords.planningRecords.length - 1]
            ?.createdTimestamp
        return createdTimestamp
      },
    ],
    createdTimestamp => {
      if (createdTimestamp) {
        return new Date(createdTimestamp)
      }
    },
  )
  getLoading = _.memoize(
    ({ loadingWhenInitial }: { loadingWhenInitial: boolean } = { loadingWhenInitial: true }) =>
      (state: RootState) =>
        loadingWhenInitial
          ? state.planningRecords.status === 'initial' || state.planningRecords.status === 'loading'
          : state.planningRecords.status === 'loading',
    props => !!props?.loadingWhenInitial,
  )
  getLoadingMore = (state: RootState) => state.planningRecords.status === 'loading-more'
  getInitial = (state: RootState) => state.planningRecords.status === 'initial'
  getHasError = (state: RootState) => state.planningRecords.status === 'failed'
  getError = (state: RootState) => state.planningRecords.error
}

export default new PlanningRecordsSelectors()
